import styled, { css } from 'styled-components';

interface SystemLabelInterface {
  color: 'blue' | 'grey';
}

export const SystemLabel = styled.span<SystemLabelInterface>`
  text-transform: uppercase;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  border-radius: 4px;
  padding: 4px 12px;
  display: inline-block;
  flex-shrink: 0;

  ${({ color }) => {
    switch (color) {
      case 'blue':
        return css`
          background-color: #1a86ce;
          color: #fff;
        `;
      case 'grey':
      default:
        return css`
          background-color: #adadad;
          color: #fff;
        `;
    }
  }}
`;
